import { Button, Checkbox, FormControlLabel, FormGroup, styled } from "@mui/material";
import { get, isEmpty } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import "./TotalConsiderationForm.css";

const StyledFormGroup = styled(FormGroup)({
    display: "inline-block",
});

const TotalConsiderationForm = (props) => {
    const {
        deal,
        disableInputs,
        errors,
        handleAutocalculateTiSf,
        handleCalculateTotalConsiderationDetails,
        handleClearRentSchedule,
        handleTotalConsiderationAmountChange,
        handleTotalConsiderationChange,
        invoice,
        totalConsideration,
        transactionType,
    } = props;

    const isComplete = deal?.isPartiallyComplete === false;

    const handleChangeEvent = (event) => {
        handleTotalConsiderationChange(event.target.id, event.target.value);
    };

    const handleCheckboxEvent = (event, checked) => {
        handleTotalConsiderationChange(event.target.value, checked);
    };

    if (totalConsideration.escalationRateType == null) {
        handleTotalConsiderationChange("escalationRateType", "%");
    }

    return (
        <form>
            {transactionType !== "SALE" && (
                <div>
                    <div className="totalConsiderationFlexContainer">
                        <small className="totalConsiderateNote">
                            Please input the fields marked as required below. Generating your rent schedule is not
                            required. If you do generate your rent schedule, this information can be auto-populated on a
                            KM Invoice by clicking the "Generate Invoice" button at the top of this form. The generated
                            invoice will be in a word document, so you can make changes as needed.
                        </small>
                    </div>
                    <div className="totalConsiderationFlexContainer">
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="totalConsiderationAmount"
                                    helperText="Required"
                                    errorText="Required"
                                    label="TOTAL CONSID. (OFFICIAL)*"
                                    toolTipText="This is the official Total Consideration for the transaction.
                                            This is a free form field, so it is not dependent on the optional calendar below.
                                            If you would like, you can input this field with the additional required fields and
                                            move forward without calculating the rent roll."
                                    value={get(deal, "totalConsiderationAmount", null)}
                                    error={errors.totalConsiderationAmount}
                                    onChange={(e) => handleTotalConsiderationAmountChange(e.target.value)}
                                    placeholder="Total Consideration Amount"
                                    disabled={disableInputs === true}
                                    startAdornment="$"
                                    numeric
                                />
                            </div>
                        </div>
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="commencementDate"
                                    label="Commencement Date*"
                                    helperText="Required"
                                    errorText="Required"
                                    value={totalConsideration.commencementDate}
                                    error={errors.commencementDate}
                                    onChange={handleChangeEvent}
                                    placeholder="Commencement Date"
                                    disabled={disableInputs === true}
                                    type="date"
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="expirationDate"
                                    label="Expiration Date*"
                                    helperText="Required"
                                    errorText="Required"
                                    value={totalConsideration.expirationDate}
                                    error={errors.expirationDate}
                                    onChange={handleChangeEvent}
                                    placeholder="Expiration Date"
                                    disabled={disableInputs === true}
                                    type="date"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="totalConsiderationFlexContainer">
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="termNumMonths"
                                    label="Term (Months)*"
                                    helperText="Required"
                                    errorText="Required (ex. 9)"
                                    error={errors.termNumMonths}
                                    value={totalConsideration.termNumMonths}
                                    onChange={handleChangeEvent}
                                    disabled={disableInputs === true}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="squareFeet"
                                    label="Square Feet*"
                                    helperText="Required"
                                    errorText="Required (ex. 98101)"
                                    error={errors.squareFeet}
                                    value={totalConsideration.squareFeet}
                                    onChange={handleAutocalculateTiSf}
                                    placeholder="Enter square feet"
                                    disabled={disableInputs === true}
                                    integer
                                />
                            </div>
                        </div>
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="preTermFreeMonths"
                                    error={errors.preTermFreeMonths}
                                    value={totalConsideration.preTermFreeMonths}
                                    label="STARTING FREE MONTHS (OUTSIDE TERM)"
                                    toolTipText="If your lease has starting free months outside of the term, please input them here.
                                                        If your lease only has free months inside the term, please disregard this field and
                                                        input your free months by expanding the term that is generated by the calculator below."
                                    onChange={handleChangeEvent}
                                    disabled={disableInputs === true}
                                    placeholder="Number free months before term"
                                    integer
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="postTermFreeMonths"
                                    error={errors.postTermFreeMonths}
                                    value={totalConsideration.postTermFreeMonths}
                                    label="ENDING FREE MONTHS (OUTSIDE TERM)"
                                    toolTipText="If your lease has ending free months outside of the term, please input them here.
                                                        If your lease only has free months inside the term, please disregard this field and
                                                        input your free months by expanding the term that is generated by the calculator below."
                                    onChange={handleChangeEvent}
                                    placeholder="Number free months after term"
                                    disabled={disableInputs === true}
                                    integer
                                />
                            </div>
                        </div>
                    </div>

                    <div className="totalConsiderationFlexContainer">
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="ratePerSqftPerMonth"
                                    label="Rent Per SF Per Month*"
                                    helperText="Required"
                                    errorText="Required (ex. 981.01)"
                                    error={errors.ratePerSqftPerMonth}
                                    value={totalConsideration.ratePerSqftPerMonth}
                                    onChange={handleChangeEvent}
                                    startAdornment="$"
                                    disabled={disableInputs === true}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="ratePerSqftPerYear"
                                    label="Rent Per SF Per Year*"
                                    helperText="Required"
                                    errorText="Required (ex. 981.01)"
                                    error={errors.ratePerSqftPerYear}
                                    value={totalConsideration.ratePerSqftPerYear}
                                    onChange={handleChangeEvent}
                                    startAdornment="$"
                                    disabled={disableInputs === true}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="ratePerMonth"
                                    label="Rent Per Month*"
                                    helperText="Required"
                                    errorText="Required (ex. 981.01)"
                                    error={errors.ratePerMonth}
                                    value={totalConsideration.ratePerMonth}
                                    onChange={handleChangeEvent}
                                    startAdornment="$"
                                    disabled={disableInputs === true}
                                />
                            </div>
                        </div>
                        <div className="totalConsiderationFlexContainerUnresponsive">
                            <div className="totalConsiderationEscalationContainer">
                                <div className="flexGrowSingle">
                                    <BSInput
                                        id="escalationRate"
                                        label={isComplete ? "Escalation Rate*" : "Escalation Rate"}
                                        helperText={isComplete ? "Required" : ""}
                                        errorText="Required (ex. 981.01)"
                                        value={totalConsideration.escalationRate}
                                        error={isComplete ? errors.escalationRate : false}
                                        onChange={handleChangeEvent}
                                        placeholder="Enter escalation rate"
                                        disabled={disableInputs === true}
                                        extraInputStyles={{ borderRadius: "4px 0px 0px 4px" }}
                                    />
                                </div>
                                <div style={{ width: "fit-content" }}>
                                    <BSSelect
                                        id="escalationRateType"
                                        fullWidth
                                        combinedField="shiftLeft"
                                        error={isComplete ? errors.escalationRate : false}
                                        value={totalConsideration.escalationRateType}
                                        onChange={handleChangeEvent}
                                        disabled={disableInputs === true}
                                        options={[
                                            {
                                                value: "%",
                                                label: "%",
                                            },
                                            {
                                                value: "$",
                                                label: "$",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="escalationTerm"
                                    label={
                                        isComplete ? "Escalation Frequency (Months)*" : "Escalation Frequency (Months)"
                                    }
                                    helperText={isComplete ? "Required" : ""}
                                    errorText="Required"
                                    value={totalConsideration.escalationTerm}
                                    error={isComplete ? errors.escalationTerm : false}
                                    placeholder="Enter months"
                                    disabled={disableInputs === true}
                                    onChange={handleChangeEvent}
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <StyledFormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color={"primary"}
                                        checked={totalConsideration.escalateAtYearStart ? true : false}
                                        onChange={(e, c) => handleCheckboxEvent(e, c)}
                                        value="escalateAtYearStart"
                                        disabled={disableInputs === true}
                                    />
                                }
                                label="Escalate at 1st of the year?"
                            />
                        </StyledFormGroup>
                    </div>

                    <div>
                        {disableInputs !== true &&
                            (!invoice ||
                                (invoice && !invoice["periods"]) ||
                                (invoice && invoice["periods"] && isEmpty(invoice["periods"]))) && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleCalculateTotalConsiderationDetails}
                                    style={{ marginLeft: "0" }}
                                >
                                    Generate Rent Schedule (Optional)
                                </Button>
                            )}

                        {disableInputs !== true && invoice && invoice["periods"] && !isEmpty(invoice["periods"]) && (
                            <Button variant="contained" color="primary" onClick={handleClearRentSchedule}>
                                Clear Rent Schedule
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </form>
    );
};

export default TotalConsiderationForm;
